<template>
    <div>
        <iframe class="mb-5" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15916.858192193517!2d73.5129926!3d4.1781834!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2da8508cd9343f51!2sAttorney%20General&#39;s%20Office!5e0!3m2!1sen!2smv!4v1598904450210!5m2!1sen!2smv" width="100%" height="250" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        <!-- <p class="headline mt-5">Attorney General's Office</p> -->
        <span  v-html="edited"></span>
    </div>
</template>
<script>
    export default {
        props: ['contents'],
        data: ()=>({
            profiles: [],
            edited: null
        }),
        created () {
            const regex = /ފޯނު:/gi;
            const regex2 = /ފެކްސް:/gi;
            const regex3 = /އީ-މެއިލް:/gi;
            this.edited = this.contents[0].Body.replace(regex, `<i aria-hidden="true" class="v-icon primary--text notranslate mdi mdi-phone theme--light"></i>`)
            this.edited = this.edited.replace(regex2, `<i aria-hidden="true" class="v-icon primary--text notranslate mdi mdi-fax theme--light"></i>`)
            this.edited = this.edited.replace(regex3, `<i aria-hidden="true" class="v-icon primary--text notranslate mdi mdi-email theme--light"></i>`)
        },
        methods: {
        }
    }
</script>